import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Floorplan: React.FC<SvgIconProps> = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M1.25 1.25V14.65H12.82V22.75H22.75V1.25H1.25ZM21.25 13.15H18.31V14.64H21.25V21.25H14.32V9.14H12.82V13.14H2.75V2.75H12.82V5.47H14.32V2.75H21.25V13.15Z" />
  </SvgIcon>
);
